import React from "react"

import { LifecycleImportFilters } from "client/store"
import { SearchBar } from "client/components"

interface SearchLifecycleImport {
    id: string
    leftOffset?: boolean
    rightOffset?: boolean
    filters: LifecycleImportFilters
    onFilter: (filters: LifecycleImportFilters) => void
}

const CcLibrarySetImportSearch = ({
    id,
    leftOffset = false,
    rightOffset = false,
    filters,
    onFilter,
}: SearchLifecycleImport) => (
    <SearchBar
        id={id}
        filters={filters}
        leftOffset={leftOffset}
        rightOffset={rightOffset}
        onFilter={onFilter}
    />
)
export default CcLibrarySetImportSearch
